/* tslint:disable */
/* eslint-disable */
export enum BidState {
  Highest = 'highest',
  Won = 'won',
  Deleted = 'deleted',
  OutBid = 'out_bid'
}
